<template>
<div>
  <!-- 编辑模板 -->
  <el-drawer

    ref="drawer"
    :visible.sync="editVisible"
    :wrapper-closable="false"
    :before-close="cancelFormEdit"
    :title="editId ? '编辑模板' : '添加模板'"
    direction="rtl"
    custom-class="demo-drawer"
    size="600px">
    <div class="demo-drawer__content">
      <el-form ref="addForm" :model="addForm" :rules="rules" :validate-on-rule-change="false" label-width="125px" :key="addForm.template_type">
        <el-form-item label="模板类型" prop="template_type">
          <el-radio-group v-model="addForm.template_type" size="small" @change="template_typeChange">
            <el-radio-button :label="1">大杂会模板</el-radio-button>
            <el-radio-button :label="0">早晚会模板</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会议主题" prop="subject">
          <el-input
            v-model="addForm.subject"
            clearable
            placeholder="请输入"
            maxlength="100"
            show-word-limit />
        </el-form-item>
        <el-form-item v-for="(domain, index) in addForm.lssue" :label="'会议议题'" prop="lssue" :key="index">
          <el-input v-model="domain.value">
            <template v-if="index !== 0" slot="append">
              <i class="el-dialog__close el-icon el-icon-close" @click.prevent="removeDomain(domain)" />
            </template>
          </el-input>
        </el-form-item>
        <p style="text-align: center;">
          <i class="el-icon-circle-plus-outline " @click="addDomain" />
        </p>

        <el-form-item v-if="addForm.template_type===0" label="会议类型" prop="type_id">
          <el-select v-model="addForm.type_id" placeholder="请选择" @change="checkType">
            <el-option
              v-for="(tp,index) in meetingTypeList"
              :key="index"
              :disabled="tp.id !==7"
              :label="tp.type_name"
              :value="tp.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="addForm.template_type===1" label="会议类型" prop="type_id">
          <el-select v-model="addForm.type_id" placeholder="请选择" @change="checkType">
            <el-option
              v-for="(tp,index) in meetingTypeList"
              :key="index"
              :disabled="tp.id===7"
              :label="tp.type_name"
              :value="tp.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="保密类型" prop="secrecy_type">
          <el-radio-group v-model="addForm.secrecy_type">
            <el-radio :label="0">普通会议（非保密）</el-radio>
            <el-radio :label="1">一级会议（保密）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addForm.template_type===1" label="是否需要评分" prop="is_need_score">
          <el-radio-group v-model="addForm.is_need_score">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="needDepart || addForm.type_id ===7" label="所属部门" prop="secretary_department_id">
          <el-select
            v-model="addForm.secretary_department_id"
            placeholder="请选择部门"
            @change="changeDepartment(addForm.secretary_department_id)">
            <el-option
              v-for="(item,index) in departmentList"
              :key="index"
              :label="item.department"
              :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="会议描述" >
          <el-input :autosize="{ minRows: 4}" v-model="addForm.describe" type="textarea" />
        </el-form-item>
        <el-form-item label="会议开始日期" prop="start_date" >
          <el-date-picker
            v-model="addForm.start_date"
            :picker-options="startTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="会议开始日期" />
        </el-form-item>
        <el-form-item label="会议结束日期" prop="end_date">
          <el-date-picker
            v-model="addForm.end_date"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期" />
        </el-form-item>
        <el-form-item
          v-if="addForm.template_type===1"
          label="大杂会预计时间"
          prop="start_time"
          style="width: 56%; display: inline-block;">
          <el-time-select
            v-model="addForm.start_time"
            :picker-options="{
              start: '08:00',
              step: '00:15',
              end: '20:00'
            }"
            style="width:100%"
            placeholder="选择时间"
             />
        </el-form-item>
        <span v-if="addForm.template_type===1">至</span>
        <el-form-item
          v-if="addForm.template_type===1"
          label=""
          label-width="0"
          prop="end_time"
          style="width: 38%; display: inline-block;">
          <el-time-select
            v-model="addForm.end_time"
            :picker-options="{
              start: '08:00',
              step: '00:15',
              end: '20:00',
              minTime:addForm.start_time
            }"
            style="width:172px"
            placeholder="选择时间" />
        </el-form-item>
        <el-form-item
          v-if="addForm.template_type===0"
          label="早会预计时间"
          prop="start_time"
          style="width: 56%; display: inline-block;">
          <el-time-select
            v-model="addForm.start_time"
            :picker-options="specialDepartment ? {
              start: '05:00',
              step: '00:15',
              end: '24:00'
            } : {
              start: '08:00',
              step: '00:15',
              end: '12:00'
            }"
            style="width:100%"
            placeholder="选择时间" />
        </el-form-item>
        <span v-if="addForm.template_type===0">至</span>
        <el-form-item
          v-if="addForm.template_type===0"
          label=""
          label-width="0"
          prop="end_time"
          style="width:38%; display: inline-block;">
          <el-time-select
            v-model="addForm.end_time"
            :picker-options="specialDepartment ? {
              start: '05:00',
              step: '00:15',
              end: '24:00',
              minTime:addForm.start_time
            } : {
              start: '08:00',
              step: '00:15',
              end: '12:00',
              minTime:addForm.start_time
            }"
            style="width:172px"
            placeholder="选择时间" />
        </el-form-item>
        <el-form-item v-if="addForm.template_type===0" label="晚会预计时间" style="width: 56%; display: inline-block;">
          <el-time-select
            v-model="addForm.night_start_time"
            :picker-options="{
              start: '15:00',
              step: '00:15',
              end: '20:00'
            }"
            style="width:100%"
            placeholder="选择时间" />
        </el-form-item>
        <span v-if="addForm.template_type===0">至</span>
        <el-form-item
          v-if="addForm.template_type===0"
          label=""
          label-width="0"
          style="width:38%; display: inline-block;">
          <el-time-select
            v-model="addForm.night_end_time"
            :picker-options="{
              start: '15:00',
              step: '00:15',
              end: '20:00',
              minTime:addForm.night_start_time
            }"
            style="width:172px"
            placeholder="选择时间" />
        </el-form-item>
        <el-form-item label="重复方式" prop="repeat_type">
          <el-radio-group v-model="addForm.repeat_type" @change="repeat_typeChange">
            <el-radio label="0">每天</el-radio>
            <el-radio label="1">每星期</el-radio>
            <el-radio label="2">每月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addForm.repeat_type === '2'" label="重复日期" prop="repeat_rule">
          <el-select v-model="addForm.repeat_rule" multiple clearable placeholder="请选择">
            <el-option v-for="i in 31" :key="i" :label="'每月'+i+'号'" :value="i" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="addForm.repeat_type === '1'" label="重复周期" prop="repeat_rule">
          <el-select v-model="addForm.repeat_rule" multiple clearable placeholder="请选择">
            <el-option label="周一" value="一" />
            <el-option label="周二" value="二" />
            <el-option label="周三" value="三" />
            <el-option label="周四" value="四" />
            <el-option label="周五" value="五" />
            <el-option label="周六" value="六" />
            <el-option label="周日" value="日" />
          </el-select>
        </el-form-item>
        <el-form-item label="召集人" prop="convenor">
          <el-select
            v-model="addForm.convenor"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            clearable
            placeholder="请输入"
            filterable
            remote
            reserve-keyword
            @visible-change="clearSelectList"
            @change="convenorChange">
            <el-option
              v-for="(user,index) in personInChargeList"
              :label="user.name+'('+user.username+')'"
              :value="user.userId+'/'+user.username+'/'+user.name"
              :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="主持人" prop="host">
          <el-select
            v-model="addForm.host"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            clearable
            placeholder="请输入"
            filterable
            remote
            reserve-keyword
            @visible-change="clearSelectList">
            <el-option
              v-for="(user,index) in personInChargeList"
              :label="user.name+'('+user.username+')'"
              :value="user.userId+'/'+user.username+'/'+user.name"
              :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="会议秘书" prop="secretary">
          <el-select
            v-model="addForm.secretary"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            clearable
            placeholder="请输入"
            filterable
            remote
            reserve-keyword
            @visible-change="clearSelectList">
            <el-option
              v-for="(user,index) in personInChargeList"
              :label="user.name+'('+user.username+')'"
              :value="user.userId+'/'+user.username+'/'+user.name"
              :key="index"
              :disabled="addForm.convenor === user.userId+'/'+user.username+'/'+user.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="参会人员" prop="attendees">
          <div style="width: 100%;min-height: 40px; border: 1px solid #eee;" @click="addAtendeesSelf">
            <el-tag
              v-for="(item, index) in addForm.attendees"
              :key="index"
              closable
              style="margin-left: 5px;"
              @close="tagClose(item)">{{ item.name }}({{ item.username?item.username:item.workcode }})</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="提醒时间" prop="reminder">
          <el-select v-model="addForm.reminder" placeholder="会议开始前多少分钟提醒">
            <el-option label="无提醒" value="0" />
            <el-option label="开会前5分钟提醒" value="5" />
            <el-option label="开会前15分钟提醒" value="15" />
            <el-option label="开会前30分钟提醒" value="30" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="cancelFormEdit">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submitForm()">{{ loading ? '提交中 ...' : '确 定' }}
        </el-button>
      </div>
    </div>
  </el-drawer>
  <!-- 人员选择 -->
  <user-conf v-bind.sync="selectObj" @save="saveUsre"></user-conf>
</div>
</template>

<script>
import { getUserInfoByName, getUserInfoById } from '@/api/login'
import { getDepartmentInfo } from '@/api/user'
import { addTemplate, getTemplateByid, editTemplate } from '@/api/meetingTemplate'
import userConf from '@/components/selectPerson'

export default {
  name: 'editTemplate',
  components: {
    'user-conf': userConf
  },
  data() {
    return {
      needDepart: false,
      selectLoading: false,
      loading: false,
      allUser: [],
      username: [], // 参会人相关
      count: 0, // 计数，赋值一次支持人和会议秘书
      departmentName: '', // 记录会议主题
      selectObj: {
        visible: false,
        allUser: [],
        departTree: []
      },
      personInChargeList: [], // 搜索用户相关
      specialDepartment: false,
      addForm: {
        id: '',
        startTime: '',
        template_type: 1,
        subject: '',
        lssue: [{ value: '' }],
        type_id: '',
        secrecy_type: 0,
        describe: '',
        reminder: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        night_start_time: '',
        night_end_time: '',
        repeat_type: '0',
        repeat_rule: '',
        convenor: '',
        host: '',
        secretary: '',
        attendees: [], // 参会人
        secretary_department_id: 0,
        is_need_score: 1
      },
      rules: {
        subject: [
          { required: true, message: '请填写会议主题', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请选择会议类型', trigger: 'change' }
        ],
        secrecy_type: [
          { required: true, message: '请选择保密类型', trigger: 'change' }
        ],
        describe: [
          { required: false, message: '请填写会议描述', trigger: 'blur' }
        ],
        start_time: [
          { required: true, message: '请设置开始时间', trigger: 'change' }
        ],
        end_time: [
          { required: true, message: '请设置结束时间', trigger: 'change' }
        ],
        night_start_time: [
          { required: false, message: '请设置晚会开始时间', trigger: 'change' }
        ],
        night_end_time: [
          { required: false, message: '请设置晚会开始时间', trigger: 'change' }
        ],
        reminder: [
          { required: true, message: '请设置提醒时间', trigger: 'change' }
        ],
        repeat_type: [
          { required: true, message: '请设置是否重复', trigger: 'blur' }
        ],
        repeat_rule: [
          { required: false, message: '请设置重复时间', trigger: 'change' }
        ],
        start_date: [
          { required: true, message: '请设置开始日期', trigger: 'change' }
        ],
        end_date: [
          { required: true, message: '请设置结束日期', trigger: 'change' }
        ],

        convenor: [
          { required: true, message: '请搜索召集人', trigger: 'change' }
        ],
        host: [
          { required: true, message: '请搜索主持人', trigger: 'change' }
        ],
        secretary: [
          { required: true, message: '请搜索会议秘书', trigger: 'change' }
        ],
        attendees: [
          { required: true, message: '请选择参会人员', trigger: 'change' }
        ],
        secretary_department_id: [
          { required: true, message: '请选择关联部门', trigger: 'change' }
        ],
        is_need_score: [
          { required: true, message: '请选择是否评分', trigger: 'change' }
        ],
        lssue: [
          { required: true, message: '请输入议题', trigger: 'change' }
        ]
      },
      startTime: {
        disabledDate: time => {
          const curDate1 = new Date()// 今天
          const preDate1 = new Date(curDate1.getTime() - 24 * 60 * 60 * 1000)// 昨天
          const days = this.getMonthDay(curDate1.getFullYear(), curDate1.getMonth()) - 1 // 开始时间所在月有几天(需减掉一天)
          if (this.addForm.end_date) {
            const curDate = new Date(this.addForm.end_date)// 结束日期
            const preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)// 结束日期前一天
            const lessDate = new Date(preDate.getTime() - days * 24 * 60 * 60 * 1000)// 结束日期前一个月内
            return time.getTime() >= curDate || time.getTime() <= (lessDate >= preDate1 ? lessDate : preDate1)
          } else {
            // return time.getTime() <= Date.now()
            const moreDate = new Date(curDate1.getTime() + days * 24 * 60 * 60 * 1000) // 今天之后的一个月
            return time.getTime() <= preDate1 || time.getTime() >= moreDate
          }
        }
      },
      // 结束时间大于开始时间，且小于此刻
      endTime: {
        disabledDate: time => {
          const curDate1 = new Date()// 今天
          const preDate1 = new Date(curDate1.getTime() - 24 * 60 * 60 * 1000)// 昨天
          const days = this.getMonthDay(curDate1.getFullYear(), curDate1.getMonth()) - 1 // 开始时间所在月有几天(需减掉一天)
          const moreDate1 = new Date(curDate1.getTime() + days * 24 * 60 * 60 * 1000)// 可选一个月内
          if (this.addForm.start_date) {
            const curDate = new Date(this.addForm.start_date)// 今天
            const preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)// 昨天
            const moreDate = new Date(curDate.getTime() + days * 24 * 60 * 60 * 1000)// 可选一个月内
            return time.getTime() <= preDate || time.getTime() >= (moreDate >= moreDate1 ? moreDate1 : moreDate) || time.getTime() <= preDate1
          } else {
            return time.getTime() <= preDate1 || time.getTime() >= moreDate1
          }
        }
      }

    }
  },
  props: {
    editVisible: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    editId: {
      type: Number,
      default: function() {
        return null
      }
    },
    meetingTypeList: {
      type: Array,
      default: function() {
        return []
      }
    },
    departmentList: {
      type: Array,
      default: function() {
        return []
      }
    },
    userList: {
      type: Array,
      default: function() {
        return []
      }
    },
    departTree: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    'editVisible'(val) {
      if (val) {
        this.username = []
        this.allUser = JSON.parse(JSON.stringify(this.userList))
        if (this.editId) {
          this.getEditData()
        } else {
          this.addForm.reminder = '5'
        }
      }
    }
  },
  mounted() {
    getDepartmentInfo(this.$store.getters.departmentId).then(res => {
      this.departmentName = res.data.longName + '  早晚会 ' // java组
    })
  },
  methods: {
    getEditData() {
      const loadings = this.$loading({
        lock: true,
        text: '数据处理中...',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      getTemplateByid(this.editId).then(res => {
        loadings.close()
        // this.$set(this.addForm, 'start_time', '')
        // this.$set(this.addForm, 'end_time', '')
        if (res) {
          const data = res.data.template
          // 字段名有些对不上 就先不用Object.assign(this.$data.addForm, data)
          this.addForm.id = data.id
          this.addForm.subject = data.meeting_subject
          this.addForm.type_id = data.meeting_type_id
          this.addForm.template_type = data.template_type
          this.addForm.secrecy_type = data.secrecy_type
          this.addForm.describe = data.describe
          this.addForm.start_date = data.start_date
          this.addForm.end_date = data.end_date

          this.addForm.night_start_time = data.night_start_time
          this.addForm.night_end_time = data.night_end_time
          this.addForm.repeat_type = data.repeat_type
          this.addForm.repeat_rule = data.repeat_rule
          this.addForm.reminder = String(data.reminder)
          this.addForm.host = data.extra.host.user_id + '/' + data.extra.host.workcode + '/' + data.extra.host.name
          this.addForm.convenor = data.extra.convenor.user_id + '/' + data.extra.convenor.workcode + '/' + data.extra.convenor.name
          this.addForm.secretary = data.extra.secretary.user_id + '/' + data.extra.secretary.workcode + '/' + data.extra.secretary.name
          this.addForm.attendees = data.extra.attendees
          this.addForm.is_need_score = data.is_need_score
          this.addForm.start_time = data.start_time
          this.addForm.end_time = data.end_time
          this.$nextTick(function() {
            // this.$forceUpdate()
          })

          this.username = data.extra.attendees
          // 通过会议类型ID判断是否需要关联部门
          this.needDepart = false
          this.addForm.secretary_department_id = ''
          this.meetingTypeList.forEach(element => {
            if (element.id === Number(data.meeting_type_id)) {
              if (element.is_department === 1) {
                this.needDepart = true
                this.addForm.secretary_department_id = data.secretary_department_id === 0 ? '' : data.secretary_department_id
                // 特殊部门的早会预约时间是5：00-24：00 改变判断条件的值specialDepartment
                this.specialDepartment = [16, 17, 18, 21, 22].includes(data.secretary_department_id)
              }
            }
          })
          if (data.extra.department_id) {
            this.addForm.department_id = data.extra.department_id
          } else {
            getUserInfoById(data.extra.convenor.user_id).then(res => {
              if (res) {
                this.addForm.department_id = res.data.departmentId// 召集人的部门
              }
            }).catch()
          }

          var keyMap = {
            workcode: 'username'
          }
          for (var i = 0; i < this.username.length; i++) {
            var obj = this.username[i]
            for (var key in obj) {
              var newKey = keyMap[key]
              if (newKey) {
                obj[newKey] = obj[key]
                delete obj[key]
              }
            }
          }

          const objArr = data.lssue.map(item => { return { value: item } })
          this.addForm.lssue = objArr

          const allGetUserInfo = []
          if (data.extra.convenor.user_id !== data.extra.host.user_id && data.extra.convenor.user_id !== data.extra.secretary.user_id) {
            allGetUserInfo.push(this.getUserInfoByIdFun(data.extra.convenor.user_id))
          }
          if (data.extra.host.user_id !== data.extra.secretary.user_id) { // 避免重复添加相同名字
            allGetUserInfo.push(this.getUserInfoByIdFun(data.extra.host.user_id))
          }
          allGetUserInfo.push(this.getUserInfoByIdFun(data.extra.secretary.user_id))
          // 调用Promise.all().then(res=>{})
          Promise.all(allGetUserInfo).then(res => {
            res.forEach(item => {
              this.personInChargeList.push(item)
            })
            const oldArr = JSON.parse(JSON.stringify(this.personInChargeList))
            this.personInChargeList = this.unique(oldArr)
          })
        }
      }).catch(() => {
        loadings.close()
      })
    },
    // 数组对象去重
    unique(oldArr) {
      const allArr = []
      for (var i = 0; i < oldArr.length; i++) {
        var flag = true
        for (var j = 0; j < allArr.length; j++) {
          if (oldArr[i].username === allArr[j].username) {
            flag = false
          }
        }
        if (flag) {
          allArr.push(oldArr[i])
        }
      }
      return allArr
    },
    // 根据id获取用户信息
    getUserInfoByIdFun(id) {
      return new Promise((resolve, reject) => {
        getUserInfoById(id)
          .then(res => {
            resolve(res.data)
          })
          .catch(error => {
            console.log(error)
            reject()
          })
      })
    },
    // 查询当前月有几天
    getMonthDay(year, month) {
      const days = new Date(year, month + 1, 0).getDate()
      return days
    },
    // 删除标签，参会人
    tagClose(tag) {
      this.addForm.attendees.splice(this.addForm.attendees.indexOf(tag), 1)
      this.username = this.addForm.attendees
    },
    saveUsre(params) {
      this.selectObj.visible = false
      this.username = params
      this.addForm.attendees = JSON.parse(JSON.stringify(params))
    },
    // 分页
    changeDepartment(id) {
      this.specialDepartment = [16, 17, 18, 21, 22].includes(id)
    },
    checkType() {
      this.needDepart = false
      this.addForm.secretary_department_id = ''
      this.needDepart = this.meetingTypeList.some(item => {
        return item.id === this.addForm.type_id && item.is_department === 1
      })
    },
    addAtendeesSelf() { // 添加点击参会人，自动带上自己，当空数组的时候
      // 当前是新增的话，先清空
      if (!this.editId) {
        this.username = []
        const obj = {
          name: this.$store.getters.name,
          username: this.$store.getters.username,
          userId: this.$store.getters.userId
        }
        this.username.push(obj)

        if (this.addForm.secretary) {
          const arr3 = this.addForm.secretary.split('/')
          const secretary = {
            userId: arr3[0],
            username: arr3[1],
            name: arr3[2]
          }
          this.username.push(secretary)
        }
        if (this.addForm.convenor) {
          const arr2 = this.addForm.convenor.split('/')
          const convenor = {
            userId: arr2[0],
            username: arr2[1],
            name: arr2[2]
          }
          this.username.push(convenor)
        }
        if (this.addForm.host) {
          const arr4 = this.addForm.host.split('/')
          const host = {
            userId: arr4[0],
            username: arr4[1],
            name: arr4[2]
          }
          this.username.push(host)
        }
      }

      const oldusername = JSON.parse(JSON.stringify(this.username))
      this.username = this.unique(oldusername)
      this.selectObj = {
        visible: true,
        allUser: this.allUser,
        departTree: this.departTree,
        hasChoosed: this.username // 已选择的
      }
    },
    // 清空用户
    clearSelectList(val) {
      if (val === false) {
        this.personInChargeList = []
      }
    },
    // 召集人改变一次 给其他两人赋值,第一次赋值 三个身份的人是同一个人
    convenorChange(val) {
      if (this.count === 0 && !this.editId) {
        this.addForm.host = JSON.parse(JSON.stringify(this.addForm.convenor))
        this.count++
      }
      if (val === null || val === undefined || val === '') {
        this.personInChargeList = []
      } else {
        const user_id = val.split('/')[0]
        getUserInfoById(user_id).then(res => {
          if (res) {
            this.addForm.department_id = res.data.departmentId// 召集人的部门
          }
        }).catch()
      }
    },
    // 早会模板切换问题，清空一些残留数据
    template_typeChange() {
      this.addForm.start_time = ''// 残留选早会
      this.addForm.end_time = ''// 残留选早会
      if (this.addForm.template_type === 0) {
        this.addForm.type_id = 7
        this.addForm.subject = this.departmentName
        if (!this.editId) {
          this.checkType()
        }
      } else {
        this.addForm.type_id = ''
        this.addForm.subject = ''
        this.addForm.is_need_score = 1
      }
    },
    // 添加议题
    addDomain() {
      this.addForm.lssue.push({
        value: '',
        key: Date.now()
      })
    },
    // 删除议题
    removeDomain(item) {
      const index = this.addForm.lssue.indexOf(item)
      if (index !== -1) {
        this.addForm.lssue.splice(index, 1)
      }
    },
    repeat_typeChange() {
      this.addForm.repeat_rule = ''
    },
    // 搜索用户
    getUserInfoByName(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          page_size: 10
        }
        getUserInfoByName(params).then(res => {
          this.personInChargeList = res.data.list
          this.selectLoading = false
        })
      }
    },
    submitForm() {
      if (this.editId) {
        this.submitEdit()
      } else {
        this.$nextTick(function() {
          this.submitAdd()
        })
      }
    },
    submitAdd() { // 添加模板
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 大杂会，至少有一个议题
          if (this.addForm.template_type === 1 && this.addForm.lssue[0].value === '') {
            this.$message.warning('请至少填写一个会议议题')
            return
          }
          if (this.addForm.convenor === this.addForm.secretary) {
            this.$message.warning('召集人和会议秘书不可以是同一个人')
            return
          }
          this.loading = true
          // 人的数据格式 id/工号/名字 分割成数组取出来(第二次点击就得注意了,用form代替)
          const form = JSON.parse(JSON.stringify(this.addForm))
          const arr2 = this.addForm.convenor.split('/')
          form.convenor = {
            user_id: arr2[0],
            workcode: arr2[1],
            name: arr2[2]
          }
          const arr3 = this.addForm.secretary.split('/')
          form.secretary = {
            user_id: arr3[0],
            workcode: arr3[1],
            name: arr3[2]
          }
          const arr4 = this.addForm.host.split('/')
          form.host = {
            user_id: arr4[0],
            workcode: arr4[1],
            name: arr4[2]
          }

          // const arr5 = []
          // for (const i in form.lssue) {
          //   arr5.push(form.lssue[i].value)
          // }
          // form.lssue = arr5
          form.lssue = form.lssue.map(item => item.value)

          const arr7 = JSON.parse(JSON.stringify(this.addForm.attendees))
          const arr6 = arr7.map(item => {
            return {
              name: item.name,
              workcode: item.workcode ? item.workcode : item.username,
              user_id: item.userId ? item.userId : item.user_id
            }
          })
          form.attendees = arr6
          if (!this.needDepart) {
            form.secretary_department_id = 0
          }

          addTemplate(form).then(response1 => {
            this.$refs.addForm.resetFields()
            this.count = 0
            this.addForm.lssue = []
            if (response1.code === 'success') {
              this.editSuccess()
            } else {
              this.errMsg()
              this.loading = false
            }
          }).catch(err => {
            console.log(err)
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          this.loading = false
          return false
        }
      })
    },
    submitEdit() {
      if (!this.needDepart) {
        this.addForm.secretary_department_id = 0
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.addForm.convenor === this.addForm.secretary) {
            this.$message.warning('召集人和会议秘书不可以是同一个人')
            return
          }
          this.loading = true
          // 人的数据格式 id/工号/名字 分割成数组取出来(第二次点击就得注意了,用form代替)
          const form = JSON.parse(JSON.stringify(this.addForm))
          form.night_start_time = form.night_start_time ? form.night_start_time : ''
          form.night_end_time = form.night_end_time ? form.night_end_time : ''
          const arr2 = this.addForm.convenor.split('/')
          form.convenor = {
            user_id: arr2[0],
            workcode: arr2[1],
            name: arr2[2]
          }
          const arr3 = this.addForm.secretary.split('/')
          form.secretary = {
            user_id: arr3[0],
            workcode: arr3[1],
            name: arr3[2]
          }
          const arr4 = this.addForm.host.split('/')
          form.host = {
            user_id: arr4[0],
            workcode: arr4[1],
            name: arr4[2]
          }

          // const arr5 = []
          // for (const i in form.lssue) {
          //   arr5.push(form.lssue[i].value)
          // }
          // form.lssue = arr5
          form.lssue = form.lssue.map(item => item.value)

          const arr7 = JSON.parse(JSON.stringify(this.addForm.attendees))
          const arr6 = arr7.map(item => {
            return {
              name: item.name,
              workcode: item.workcode ? item.workcode : item.username,
              user_id: item.userId ? item.userId : item.user_id
            }
          })
          form.attendees = arr6

          editTemplate(form).then(response1 => {
            if (response1.code === 'success') {
              this.editSuccess()
            } else {
              this.errMsg()
              this.loading = false
            }
          }).catch(err => {
            console.log(err)
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          this.loading = false
          return false
        }
      })
    },
    // 关闭修改
    cancelFormEdit() {
      this.loading = false
      this.needDepart = false
      // this.$refs.addForm.resetFields()
      this.count = 0
      this.addForm = {
        id: '',
        startTime: '',
        template_type: 1,
        subject: '',
        lssue: [{ value: '' }],
        type_id: '',
        secrecy_type: 0,
        describe: '',
        reminder: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        night_start_time: '',
        night_end_time: '',
        repeat_type: '0',
        repeat_rule: '',
        convenor: '',
        host: '',
        secretary: '',
        attendees: [], // 参会人
        secretary_department_id: 0,
        is_need_score: 1
      }
      this.$emit('closeDrawer')
    },
    // 添加 修改成功
    editSuccess() {
      this.loading = false
      this.needDepart = false
      this.addForm.secretary_department_id = 0
      this.addForm.lssue = []
      this.addForm.attendees = []
      this.addForm.type_id = ''
      this.$emit('editSuccess')
      this.cancelFormEdit()
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    }
  }
}
</script>

<style>
  .demo-drawer__content {
    padding: 10px 30px 100px 20px;

    height: 100vh;
    overflow: auto;
  }

  .demo-drawer__footer {
    text-align: center;
  }

  .demo-drawer__footer .el-button {
    width: 30%;
  }

  .el-date-editor--datetime {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-icon-circle-plus-outline {
    font-size: 30px;
    color: rgb(182, 160, 139);
    cursor: pointer;
  }
  .demo-drawer__footer {
    text-align: center;
        height: 17%;
  }

</style>
